<template>
  <div class="container">
    <div class="tips-box">
      <div>温馨提示：</div>
      <div>
        请用真实资料填写，方便参加行业内各项交流活动。譬如：参观线下照明展、论坛、活动报名等等
      </div>
    </div>

    <div class="info-box">
      <div class="info_item">
        <div>昵称</div>
        <div>
          <input v-model="info.NickName" />
        </div>
      </div>
      <div class="info_item">
        <div>真实姓名</div>
        <div>
          <input v-model="info.TrueName" />
        </div>
      </div>
      <div class="info_item">
        <div>职位</div>
        <div>
          <input v-model="info.Duty" />
        </div>
      </div>
      <div class="info_item">
        <div>公司名称</div>
        <div>
          <input v-model="info.CompanyName" />
        </div>
      </div>
      <div class="info_item" @click="openArea">
        <div>省份</div>
        <div>
          <input v-model="provinceCity" disabled="false" />
        </div>
      </div>
      <div class="info_item">
        <div>地址</div>
        <div>
          <input v-model="info.Address" />
        </div>
      </div>
      <div class="info_item">
        <div>电话</div>
        <div>
          <input v-model="info.Tel" />
        </div>
      </div>
      <div class="info_item">
        <div>网站</div>
        <div>
          <input v-model="info.Website" />
        </div>
      </div>
      <div class="info_item">
        <div>微信号</div>
        <div>
          <input v-model="info.WeiXin" />
        </div>
      </div>

      <div class="info_item code_item">
        <div>微信二维码</div>
        <div class="weChat">
          <img
            class="uploadImg"
            v-if="info.WeiXinQRCode"
            :src="info.WeiXinQRCode"
            alt=""
          />
          <van-uploader v-else :after-read="Uploader"> </van-uploader>
          <div class="support">格式支持JPEG、PNG</div>
        </div>
      </div>
      <div class="modifyBtn" @click.stop="updateMemberHandle">修改</div>
    </div>

    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { Picker, Popup, Toast, Uploader } from "vant";
import { uploadImg } from "@/api/publish";
import {
  getMemberInfo,
  getTreeRegionDataList,
  updateMember,
} from "@/api/member";
export default {
  name: "myFile",
  components: {
    "van-uploader": Uploader,
    "van-popup": Popup,
    "van-picker": Picker,
  },
  data() {
    return {
      info: "",
      RegionId: "",
      province: "",
      city: "",
      provinceCity: "",
      provincesIndex: 0,
      citysIndex: 0,

      columns: [],
      showPicker: false,
    };
  },
  methods: {
    //获取会员数据
    getInfo() {
      getMemberInfo().then((res) => {
        this.info = res.Data;
        this.province = res.Data.ProvinceName ? res.Data.ProvinceName : "";
        this.city = res.Data.CityName ? res.Data.CityName : "";
        this.provinceCity = this.province + "" + this.city;
        this.RegionId = res.Data.CityID ? res.Data.CityID : "";
      });
      this.getReginList();
    },

    //上传图片
    Uploader(file) {
      const param = new FormData();
      param.append("file", file.file);
      uploadImg(param).then((res) => {
        this.info.WeiXinQRCode = res.Data;
      });
    },

    //打开地址
    openArea() {
      this.showPicker = !this.showPicker;
    },

    //获取区域列表
    getReginList() {
      getTreeRegionDataList().then((res) => {
        var list = [];
        res.Data.forEach((item, index) => {
          list.push({
            text: item.RegionName,
          });
          list[index].children = [];
          if (this.province == item.RegionName) {
            this.provincesIndex = index;
            this.provincesId = item.RegionId;
          }
          item.Sub.forEach((sitem, sindex) => {
            list[index].children.push({
              text: sitem.RegionName,
            });
            if (this.city == sitem.RegionName) {
              this.citysIndex = sindex;
              this.cityId = sitem.RegionId;
            }
          });
        });
        this.columns = list;
        this.province = this.columns[this.provincesIndex].text;
        this.city = this.columns[this.provincesIndex].children[
          this.citysIndex
        ].text;
        this.provinceCity = this.province + "" + this.city;
      });
    },

    //点击确认
    onConfirm(value) {
      this.provinceCity = value;
      this.province = value[0];
      this.city = value[1];
      this.showPicker = false;
    },

    //更改会员数据
    updateMemberHandle() {
      var newInfo = this.info;
      var data = {
        TrueName: newInfo.TrueName,
        NickName: newInfo.NickName,
        Duty: newInfo.Duty,
        CompanyName: newInfo.CompanyName,
        CountryID: 2,
        Country: "",
        ProvinceID: this.provincesId,
        ProvinceName: this.province,
        CityID: this.cityId,
        CityName: this.city,
        DistrictID: 0,
        DistrictName: "",
        Address: newInfo.Address,
        Tel: newInfo.Tel,
        Fax: newInfo.Fax,
        Website: newInfo.Website,
        WeiXin: newInfo.WeiXin,
        WeiXinQRCode: newInfo.WeiXinQRCode,
      };
      updateMember(data).then((res) => {
        Toast("修改成功");
        this.$router.push("/member");
      });
    },
  },
  mounted() {
    this.getInfo();
  },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  background-color: #efefef;
  .tips-box {
    color: #999999;
    font-size: 11px;
    padding: 15px 12px 20px 12px;
    line-height: 18px;
    div {
      &:first-child {
        margin-bottom: 3px;
      }
    }
  }
  .info-box {
    background-color: #ffffff;
    padding-bottom: 100px;
    .info_item {
      color: #333333;
      font-size: 13px;
      padding: 11px 15px;
      border-top: 1px solid #dddddd;
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        &:nth-child(2) {
          width: 260px;
        }
        input {
          width: 100%;
          height: 18px;
          border: none;
          &:disabled {
            background-color: #fff;
          }
        }
      }
    }
    .code_item {
      padding: 13px 15px;
      align-items: flex-start;
      .uploadImg {
        width: 80px;
        height: 80px;
        img {
          width: 100%;
          height: 100%;
          vertical-align: top;
        }
      }
      .support {
        color: #aaaaaa;
        font-size: 9px;
        margin-top: 5px;
      }
    }
    .modifyBtn {
      width: 122px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      background: rgba(235, 78, 78, 1);
      border-radius: 2px;
      margin: 0 auto;
      margin-top: 32px;
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;
      -ms-border-radius: 2px;
      -o-border-radius: 2px;
    }
  }
}
</style>

